import type { GameController } from '../app/GameController';

let controller: GameController | null = null;

export const setController = (value: GameController): void => { controller = value; };
export const getController = (): GameController => {
  if (!controller) throw new Error('GameController must be registered before Phaser starts.');
  return controller;
};
